<p-panel styleClass="pt-3 p-panel-slimheight">
	<ng-template pTemplate="header">
		<div class="flex align-items-center">
			<span class="font-semibold">{{ 'STATE_INPUTS' | translate }}</span>
		</div>
	</ng-template>
	<ng-template pTemplate="icons">
		<p-button [disabled]="!device.CurrentlyOwned" icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}"
			tooltipPosition="bottom" (click)="editAlias()" [text]="true" severity="secondary">
		</p-button>
	</ng-template>
	<div class="grid pt-1">
		<div class="col-3 flex align-items-center justify-content-center gap-3" *ngFor="let o of inputArray; index as i">
			<p-tag [value]="i + 1" [severity]="o ? 'success' : 'danger'"></p-tag>
			<label>{{translateDataAlias(i + 1)}}</label>
		</div>
	</div>
</p-panel>